<i18n lang="json">
{
  "en": {
    "about": "About",
    "showMore": "Show more",
    "showLess": "Show less"
  },
  "fr": {
    "about": "À propos",
    "showMore": "Afficher plus",
    "showLess": "Afficher moins"
  }
}
</i18n>

<template>
  <h2 class="typography-subtitle-2 mb-6">{{ t('about') }}</h2>

  <ExpandableContent :expanded="aboutExpanded" :lines="4" class="mb-2" @expandable="showExpander = $event">
    <p class="typography-body-1">
      {{ description }}
    </p>
  </ExpandableContent>

  <FormButton v-if="showExpander" variant="link" ref="showMore" @click.prevent="toggleAboutHandler">{{
    aboutExpanded ? t('showLess') : t('showMore')
  }}</FormButton>
</template>

<script lang="ts" setup>
defineProps<{
  description: string
}>()

const { t } = useI18n()

const aboutExpanded = ref(false)
const showExpander = ref(false)

const toggleAboutHandler = () => {
  aboutExpanded.value = !aboutExpanded.value
}
</script>
